import { Avatar, Select, SelectItem, type SharedSelection, Spinner } from "@heroui/react";
import { useCallback } from "react";
import type { Address } from "viem";

type TokenData = {
  tokenAddress: Address;
  tokenSymbol: string;
};

export function BridgeTokenSelector({
  tokens,
  selectedToken,
  onTokenChange,
}: {
  tokens: TokenData[] | undefined;
  selectedToken: Address;
  onTokenChange: (token: Address) => void;
}) {
  const handleSelectionChange = useCallback(
    (keys: SharedSelection) => {
      if (keys.anchorKey) {
        onTokenChange(keys.anchorKey as Address);
      }
    },
    [onTokenChange],
  );

  if (tokens === undefined) {
    return (
      <div className="basis-36 flex justify-center items-center">
        <Spinner />
      </div>
    );
  }

  return (
    <Select
      selectionMode="single"
      items={tokens}
      selectedKeys={[selectedToken.toLowerCase()]}
      onSelectionChange={handleSelectionChange}
      radius="none"
      size="lg"
      classNames={{
        base: "basis-36 justify-center",
        innerWrapper: "px-1",
        trigger: "data-[hover=true]:bg-transparent shadow-none",
        popoverContent: "turnstile-card-border",
      }}
      aria-label="bridge token selector"
      renderValue={(items) =>
        items.map((item) => (
          <div className="flex gap-2 items-center" key={item.key}>
            <Avatar name={item.data?.tokenSymbol[0]} color="primary" classNames={{ base: "!size-6" }} />
            <span className="font-semibold">{item.data?.tokenSymbol}</span>
          </div>
        ))
      }
    >
      {(tokenData) => (
        <SelectItem key={tokenData.tokenAddress.toLowerCase()} textValue={tokenData.tokenSymbol}>
          <div className="flex gap-2 items-center">
            <Avatar name={tokenData.tokenSymbol[0]} color="primary" classNames={{ base: "!size-6" }} />
            {tokenData.tokenSymbol}
          </div>
        </SelectItem>
      )}
    </Select>
  );
}
